import { Tab } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';

const StyledTab = (props: any) => {
    const {
        // Needs to be extracted so classes isn't passed into Tab via otherProps
        classes,
        style,
        // Extracted to prevent forwarding to the DOM; still passed into muiStyles for overrides
        tabClasses,
        ...otherProps
    } = props;

    const {
        basic,
        basicFontThin,
        thin,
        selected
    } = muiStyles({
        ...otherProps,
        tabClasses
    });

    const tabStyle = React.useMemo(() => {
        let root = basic;

        if (style === 'basicFontThin') {
            root = basicFontThin;
        }

        if (style === 'thin') {
            root = thin;
        }

        return {
            root,
            selected
        };
    }, [ style, tabClasses ]);

    return (
        <Tab
            {...otherProps}
            classes={tabStyle}
        />
    );
};

export default StyledTab;